/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-26 11:37:57
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-27 16:29:57
 * @FilePath: /wemeet-admin-new/src/api/recruitment/brand.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

// 查询招聘机构组
export function queryRecruitmentBrandGroup(params) {
  return request({
    url: '/user/admin/enterprise/job/group/query',
    method: 'GET',
    params,
  })
}

// 新增招聘机构组
export function addRecruitmentBrandGroup(data) {
  return request({
    url: '/user/admin/enterprise/job/group/add',
    method: 'POST',
    data,
  })
}

// 修改招聘机构组
export function editRecruitmentBrandGroup({ id, ...data }) {
  return request({
    url: `/user/admin/enterprise/job/group/updateEnterpriseJobGroup/${id}`,
    method: 'POST',
    data,
  })
}

// 删除招聘机构组
export function delRecruitmentBrandGroup(id) {
  return request({
    url: `/user/admin/enterprise/job/group/delEnterpriseJobGroup/${id}`,
    method: 'POST',
  })
}

// 查询招聘机构列表
export function queryRecruitmentBrandList(params) {
  return request({
    url: '/user/admin/enterprise/job/group/enterprise/queryList',
    method: 'GET',
    params,
  })
}

// 添加机构组和机构的绑定关系
export function addRecruitmentBrandRef(data) {
  return request({
    url: '/user/admin/enterprise/job/group/addEnterpriseRef',
    method: 'POST',
    data,
  })
}

// 删除机构组和机构的绑定关系
export function delRecruitmentBrandRef({ id, ...data }) {
  return request({
    url: `/user/admin/enterprise/job/group/delEnterpriseCodeRef/${id}`,
    method: 'POST',
    data,
  })
}
